import { useSelector } from "react-redux"
import { AboutWrapper, AboutHeader } from "./AboutStyle"
import OurGoal from "./01_our_goal/OurGoal"
import FirstThreeColumns from "./02_first_three/FirstThreeColumns"
import Statistics from "./03_stats/Statistics"
import SecondThreeColumns from "./04_second_three/SecondThreeColumns"
import { about } from "../../i18n/03_about"

const Contacts = () => {

  const lang = useSelector(state => state.lang.lang)

  const t = about[lang]

  return (
    <AboutWrapper>
      <AboutHeader>
        {t.aboutHeader}
      </AboutHeader>
      <OurGoal/>
      <FirstThreeColumns/>
      <Statistics/>
      <SecondThreeColumns/>
    </AboutWrapper>
  )
}

export default Contacts